import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { Search } from '../../../shared/user.model';

@Component({
  selector: 'app-department-grid',
  templateUrl: './department-grid.component.html',
  styleUrls: ['./department-grid.component.css']
})
export class DepartmentGridComponent implements OnInit {
  title="Department";
  itemsPerPage: number=5;
  currentPage: number=1;
  DepartmentDetailsList : any = {};
  data : any = {};  
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  dep_Id : number;
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }
   ngOnInit() { 
    this.GetDepartmentDetails(this.itemsPerPage, 1)
  }

 

  //List of Case Proceedings
  GetDepartmentDetails(itemsPerPage:any,pageNo:any){
  //alert('Inside');
  this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.UserService.GetDepartmentDetails(itemsPerPage,pageNo);
    this.data.subscribe(
      (response: any) => {
        this.DepartmentDetailsList = response.DepartmentModel;
          this.totalItems = response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        console.log('department Deatils');
        console.log(this.DepartmentDetailsList);    
        document.getElementById('loader-spinner').style.display = "none";
      },(error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.HandlerError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  delete(dep_Id){
    swal({
       title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
     }).then((result) => {
        if (result.value) {
        this.data = this.UserService.DeleteDepartment(dep_Id);
        this.data.subscribe(
         (response: any) => {
          this.GetDepartmentDetails(this.itemsPerPage, 1)
            //alert('Inside');;          
         },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }      
      ); 
    } 
    })
    }

    pageChanged(pageNumber: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else
        this.GetDepartmentDetails(this.itemsPerPage, pageNumber);
    }
  
    itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNo);
      else
        this.GetDepartmentDetails(this.itemsPerPage, pageNo);
    }


  //Search item


  onSearch(s, itemsPerPage: number, pageNo: number) {   
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.UserService.SearchDepartment(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.DepartmentModel.length!=0){              
            this.DepartmentDetailsList = data.DepartmentModel;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          document.getElementById('loader-spinner').style.display = "none";         
          }
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/masters/department/department-grid/department-grid.component.ts